import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import { FaAddressBook, FaArrowRight, FaChartLine, FaFileInvoiceDollar, FaIndustry } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import Layout from "../../components/Layout";
import { hasScreenAccess } from "../../utils/screens";

const Commercial = () => {
  const navigate = useNavigate();
  const auth = useAuthUser<any>();
  const entries = [
    {
      title: "Clientes Ativos",
      description: "Cadastros, margens, honorários e condições negociadas.",
      link: "/commercial/clients",
      icon: <FaAddressBook />,
    },
    {
      title: "Fornecedores",
      description: "Fábricas, marcas, condições de pagamento e calendário de pedidos.",
      link: "/commercial/suppliers",
      icon: <FaIndustry />,
    },
    {
      title: "Vendas",
      description: "NF-e de venda da Distribuidora: própria e por encomenda.",
      link: "/commercial/sales",
      icon: <FaFileInvoiceDollar />,
    },
    {
      title: "CRM",
      description: "Leads, tarefas, funil e estimativas comerciais.",
      link: "/commercial/crm/leads",
      icon: <FaChartLine />,
    },
  ].filter((entry) => hasScreenAccess(auth, entry.link));

  return (
    <Box minH="100vh" bg="var(--main-bg-color)">
      <Layout>
        <Box p={{ base: "24px", md: "48px" }}>
          <Box maxW="820px" mb="38px">
            <Text color="var(--icon-color)" fontWeight="700" fontSize="sm" letterSpacing="0.08em">
              COMERCIAL
            </Text>
            <Heading mt="8px" size="xl">Onde você quer trabalhar?</Heading>
            <Text mt="10px" color="gray.500">
              Clientes Ativos, Fornecedores, Vendas e CRM têm permissões independentes.
            </Text>
          </Box>
          <Flex gap="18px" flexWrap="wrap">
            {entries.map((entry) => (
              <Box key={entry.link} w={{ base: "100%", md: "360px" }} bg="white" border="1px solid" borderColor="gray.200" borderRadius="16px" p="24px" boxShadow="sm">
                <Flex color="var(--icon-color)" fontSize="25px" mb="22px">{entry.icon}</Flex>
                <Heading size="md">{entry.title}</Heading>
                <Text color="gray.500" mt="8px" minH="48px">{entry.description}</Text>
                <Button mt="22px" rightIcon={<FaArrowRight />} colorScheme="blue" onClick={() => navigate(entry.link)}>
                  Abrir
                </Button>
              </Box>
            ))}
          </Flex>
        </Box>
      </Layout>
    </Box>
  );
};

export default Commercial;
